<template lang="pug">
    div
        navbar(:opaque="true")
        router-view
        the-footer
</template>

<script>
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'

export default {
    name: 'news',
    components: { Navbar, TheFooter }
}
</script>
